  (function () {
    if (customElements.get('carmine-pairs-well')) return;

    class CarminePairsWell extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.pairs-well__track');
        this.arrows = Array.from(this.querySelectorAll('.pairs-well__arrow'));
        this.arrows.forEach(function (btn) {
          btn.addEventListener('click', this.scrollByCard.bind(this, parseInt(btn.dataset.dir, 10)));
        }, this);
        this.track.addEventListener('scroll', this.updateArrows.bind(this), { passive: true });
        this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: this.dataset.currency || 'EUR',
        });
        this.load();
      }

      async load() {
        try {
          var cartIds = (this.dataset.cartProducts || '').split(',').filter(Boolean);
          if (!cartIds.length) return;
          var base = this.dataset.recsUrl || '/recommendations/products';
          var limit = parseInt(this.dataset.limit || '6', 10);
          var seen = new Set(cartIds.map(Number));
          var recs = [];
          var intents = ['complementary', 'related'];
          for (var i = 0; i < intents.length && !recs.length; i++) {
            var lists = await Promise.all(
              cartIds.slice(0, 3).map(function (id) {
                return fetch(base + '.json?product_id=' + id + '&limit=' + limit + '&intent=' + intents[i])
                  .then(function (r) { return r.ok ? r.json() : { products: [] }; })
                  .catch(function () { return { products: [] }; });
              })
            );
            lists.forEach(function (list) {
              (list.products || []).forEach(function (p) {
                if (!seen.has(p.id)) { seen.add(p.id); recs.push(p); }
              });
            });
          }
          recs = recs.slice(0, limit);
          var cards = recs.map(this.buildCard, this).filter(Boolean);
          if (!cards.length) return;
          cards.forEach(function (c) { this.track.appendChild(c); }, this);
          this.classList.add('is-ready');
          this.updateArrows();
        } catch (e) {
          /* keep hidden on any failure */
        }
      }

      buildCard(product) {
        var variants = (product.variants || []).filter(function (v) { return v.available; });
        if (!variants.length) return null;
        var card = document.createElement('div');
        card.className = 'pairs-well__card';
        card.setAttribute('role', 'listitem');

        var row = document.createElement('div');
        row.className = 'pairs-well__row';

        var img = document.createElement('img');
        img.className = 'pairs-well__img';
        img.loading = 'lazy';
        img.width = 180;
        img.height = 223;
        img.alt = product.title;
        var src = product.featured_image || (product.images && product.images[0]) || '';
        if (src) img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=180';
        row.appendChild(img);

        var info = document.createElement('div');
        info.className = 'pairs-well__info';
        var name = document.createElement('p');
        name.className = 'pairs-well__name';
        name.textContent = product.title;
        var price = document.createElement('p');
        price.className = 'pairs-well__price';
        price.textContent = this.money.format(variants[0].price / 100);
        info.appendChild(name);
        info.appendChild(price);
        row.appendChild(info);

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pairs-well__add';
        btn.textContent = '+ ADD';
        btn.dataset.variantId = variants[0].id;
        btn.addEventListener('click', this.addToCart.bind(this, btn));
        row.appendChild(btn);

        card.appendChild(row);

        if (variants.length > 1) {
          var wrap = document.createElement('div');
          wrap.className = 'pairs-well__variants';
          var select = document.createElement('select');
          select.className = 'pairs-well__select';
          select.setAttribute('aria-label', 'Select option');
          variants.forEach(function (v) {
            var opt = document.createElement('option');
            opt.value = v.id;
            opt.textContent = v.title;
            opt.dataset.price = v.price;
            select.appendChild(opt);
          });
          select.addEventListener('change', function () {
            btn.dataset.variantId = select.value;
            var chosen = select.options[select.selectedIndex];
            price.textContent = this.money.format(parseInt(chosen.dataset.price, 10) / 100);
          }.bind(this));
          wrap.appendChild(select);
          card.appendChild(wrap);
        }

        return card;
      }

      async addToCart(btn) {
        if (btn.disabled) return;
        var original = btn.textContent;
        btn.disabled = true;
        btn.textContent = '...';
        try {
          var drawer = document.querySelector('cart-drawer');
          var canRender = drawer
            && typeof drawer.getSectionsToRender === 'function'
            && typeof drawer.renderContents === 'function';
          var body = { items: [{ id: parseInt(btn.dataset.variantId, 10), quantity: 1 }] };
          if (canRender) {
            body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
            body.sections_url = window.location.pathname;
          }
          var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
          var res = await fetch(addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
            body: JSON.stringify(body),
          });
          var data = await res.json();
          if (!res.ok || data.status) throw new Error(data.description || 'Could not add to cart');
          if (canRender && data.sections) {
            drawer.renderContents(data);
          } else {
            window.location.reload();
          }
        } catch (e) {
          btn.disabled = false;
          btn.textContent = original;
        }
      }

      scrollByCard(dir) {
        var card = this.track.querySelector('.pairs-well__card');
        if (!card) return;
        this.track.scrollBy({ left: dir * (card.offsetWidth + 10), behavior: 'smooth' });
      }

      updateArrows() {
        var max = this.track.scrollWidth - this.track.clientWidth;
        var pos = this.track.scrollLeft;
        if (this.arrows.length === 2) {
          this.arrows[0].disabled = pos <= 2;
          this.arrows[1].disabled = pos >= max - 2;
        }
      }
    }

    customElements.define('carmine-pairs-well', CarminePairsWell);
  })();
